import { API_ENDPOINTS } from "@/constants/api";

export interface PaymentLinkResponse {
  checkoutUrl: string | null;
  alreadyPaid?: boolean;
}

export const BillingService = {
  /**
   * Create a Revolut hosted checkout URL for a specific invoice.
   * Returns the URL to redirect the customer to for payment.
   */
  getPaymentLink: async (invoiceId: string): Promise<PaymentLinkResponse> => {
    const response = await fetch(API_ENDPOINTS.BILLING.REVOLUT_PAY, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ invoiceId }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || "Failed to create payment link");
    }

    return response.json();
  },
};
